import { render } from "./ClientReviews.vue?vue&type=template&id=f65e7d22"
import script from "./ClientReviews.vue?vue&type=script&lang=js"
export * from "./ClientReviews.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__